import React, { useState } from 'react';
import PersonalInfo from './PersonalInfo';
import Projectstudentinfo from './Projectstudentinfo';
import Experienceinfo from './Experienceinfo';
import AdminAppBody from '../../../../components/admin/AdminAppBody';

const UpdateStudentProfile = () => {
  const [activeComponent, setActiveComponent] = useState('personal');

  const renderComponent = () => {
    switch (activeComponent) {
      case 'personal':
        return <PersonalInfo />;
      case 'project':
        return <Projectstudentinfo />;
      case 'experience':
        return <Experienceinfo />;
      default:
        return null;
    }
  };

  return (
    
    <AdminAppBody
      content={
        <div className="container  py-4">
          <div className="d-flex gap-2 mb-4">
            <button
              className={`btn btn-outline-primary ${activeComponent === 'personal' ? 'active' : ''}`}
              onClick={() => setActiveComponent('personal')}
            >
              Personal Info
            </button>
            <button
              className={`btn btn-outline-primary ${activeComponent === 'project' ? 'active' : ''}`}
              onClick={() => setActiveComponent('project')}
            >
              Projects
            </button>
            <button
              className={`btn btn-outline-primary ${activeComponent === 'experience' ? 'active' : ''}`}
              onClick={() => setActiveComponent('experience')}
            >
              Experiences
            </button>
          </div>
          {renderComponent()}
        </div>
      }
    />
  );
};

export default UpdateStudentProfile;
